import { render, staticRenderFns } from "./ToPack.vue?vue&type=template&id=6cbf8e2b&scoped=true"
import script from "./ToPack.vue?vue&type=script&lang=js"
export * from "./ToPack.vue?vue&type=script&lang=js"
import style0 from "./ToPack.vue?vue&type=style&index=0&id=6cbf8e2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf8e2b",
  null
  
)

export default component.exports